import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { toast } from "react-toastify";

const TotalSection = ({
    items,
    shipping,
    setShipping,
    customerNote,
    setCustomerNote,
    advance_payment,
    setAdvancePayment,
    setTotals,
    editInvoice
}) => {

    const [calculatedTotals, setCalculatedTotals] = useState({
        subtotal: 0,
        discount_amount: 0,
        tax: 0,
        grand_total: 0,
        pending: 0,
    });
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const subtotal1 = items.reduce((acc, item) => {
        const rate = parseFloat(item.rate || 0);
        const qty = parseFloat(item.quantity || 1);
        return acc + (rate * qty);
    }, 0);
    const [subtotal, setSubtotal] = useState(subtotal1);
    console.log(items)

    const discountPercent = (items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0);
    const discount_amount = subtotal * discountPercent / 100;

    const taxPercent = (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0);
    const tax = (subtotal - discount_amount) * taxPercent / 100;
    const grand_total = subtotal - discount_amount + tax + parseFloat(shipping || 0);
    const pending = subtotal - discount_amount - (parseFloat(advance_payment) || 0) + tax + parseFloat(shipping || 0);
    console.log(discount_amount)


    useEffect(() => {
        const calculatedSubtotal = items.reduce((acc, row) => {
            const quantity = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            return acc + quantity * rate;
        }, 0);
        setSubtotal(calculatedSubtotal);
    }, [items]);


    const discountAmount = items.reduce((acc, item) => {
        // If the row already has a final amount, don't apply a discount calc
        if (item.amount !== undefined && item.amount !== null && item.amount !== "") {
            return acc;
        }
        const rate = parseFloat(item.rate || 0);
        const qty = parseFloat(item.quantity || 1);
        const discount = parseFloat(item.discount || 0);
        return acc + ((rate * qty) * discount / 100);
    }, 0);

    useEffect(() => {
        setTotals({
            subtotal,
            discount_amount,
            advance_payment,
            pending,
            tax,
            shipping,
            grand_total
        });
    }, [subtotal, discount_amount, advance_payment, pending, tax, shipping, grand_total, setTotals]);

    const hasAmount = items.every(item => item.amount !== undefined && item.amount !== null);

    const calculatedSubtotal = items.reduce((acc, item) => {
        return acc + (item.amount ? parseFloat(item.amount || 0) : (parseFloat(item.rate || 0) * parseFloat(item.quantity || 1)));
    }, 0);

    // Always compute discount/tax from rate/qty when present (do not zero just because amount exists).
    const calculatedDiscount = items.reduce((acc, item) => {
        const rate = parseFloat(item.rate || 0);
        const qty = parseFloat(item.quantity || 0);
        if (!(rate > 0 && qty > 0)) return acc;
        const discount = parseFloat(item.discount || 0);
        return acc + ((rate * qty) * discount / 100);
    }, 0);

    const calculatedTax = items.reduce((acc, item) => {
        const rate = parseFloat(item.rate || 0);
        const qty = parseFloat(item.quantity || 0);
        if (!(rate > 0 && qty > 0)) return acc;
        const discount = parseFloat(item.discount || 0);
        const tax = parseFloat(item.tax || 0);
        const taxable = (rate * qty) * (1 - discount / 100);
        return acc + (taxable * tax / 100);
    }, 0);

    const grandTotal = calculatedSubtotal - calculatedDiscount + calculatedTax + parseFloat(shipping || 0);
    const pendingAmount = grandTotal - parseFloat(advance_payment || 0);


    // const calculatedDiscount = (() => {
    //     let fullSubtotal = items.reduce((acc, item) => {
    //         const rate = parseFloat(item.rate || 0);
    //         const qty = parseFloat(item.quantity || 1);
    //         return acc + (rate * qty);
    //     }, 0);

    //     let subtotalFromAmountItems = items.reduce((acc, item) => {
    //         return acc + (item.amount ? parseFloat(item.amount || 0) : 0);
    //     }, 0);

    //     let eligibleDiscountItems = items.filter(item => !item.amount);

    //     let discountAmount = eligibleDiscountItems.reduce((acc, item) => {
    //         const rate = parseFloat(item.rate || 0);
    //         const qty = parseFloat(item.quantity || 1);
    //         const discount = parseFloat(item.discount || 0);
    //         return acc + ((rate * qty) * discount / 100);
    //     }, 0);

    //     return discountAmount;
    // })();

    const discountedampunt = calculatedDiscount;



    // const calculatedTax = items.reduce((acc, item) => {
    //     if (item.amount) return acc;
    //     const rate = parseFloat(item.rate || 0);
    //     const qty = parseFloat(item.quantity || 1);
    //     const discount = parseFloat(item.discount || 0);
    //     const tax = parseFloat(item.tax || 0);
    //     const taxable = (rate * qty) * (1 - discount / 100);
    //     return acc + (taxable * tax / 100);
    // }, 0);

    // const pendingAmount = calculatedSubtotal - calculatedDiscount - parseFloat(advance_payment || 0) + calculatedTax + parseFloat(shipping || 0);

    // const grandTotal = calculatedSubtotal - calculatedDiscount + calculatedTax + parseFloat(shipping || 0);
    // const grandTotal =
    //     calculatedSubtotal - calculatedDiscount + calculatedTax + parseFloat(shipping || 0);

    // const pendingAmount = grandTotal - parseFloat(advance_payment || 0);

    useEffect(() => {
        setTotals({
            subtotal: calculatedSubtotal,
            discount_amount: calculatedDiscount,
            advance_payment,
            pending: pendingAmount,
            tax: calculatedTax,
            shipping,
            grand_total: grandTotal
        });
    }, [items, calculatedSubtotal, calculatedDiscount, advance_payment, pendingAmount, calculatedTax, shipping, grandTotal]);

    useEffect(() => {
        // Calculate subtotal
        const subtotal = items.reduce(
            (acc, item) =>
                acc +
                (item.amount
                    ? parseFloat(item.amount)
                    : (parseFloat(item.rate) || 0) * (parseFloat(item.quantity) || 1)),
            0
        );

        // Calculate discount (average percent discount)
        const discountPercent =
            items.reduce((acc, item) => acc + (parseFloat(item.discount) || 0), 0) /
            items.length || 0;
        const discount_amount = (subtotal * discountPercent) / 100;

        // Calculate tax (average percent tax)
        const taxPercent =
            items.reduce((acc, item) => acc + (parseFloat(item.tax) || 0), 0) /
            items.length || 0;
        const tax = ((subtotal - discount_amount) * taxPercent) / 100;

        const grand_total = subtotal - discount_amount + tax + (parseFloat(shipping) || 0);

        const pending = grand_total - (parseFloat(advance_payment) || 0);

        // Update local calculated totals
        setCalculatedTotals({
            subtotal,
            discount_amount,
            tax,
            grand_total,
            pending,
        });

        // Also update totals in parent
        setTotals({
            subtotal,
            discount_amount,
            advance_payment,
            tax,
            shipping,
            grand_total,
            pending,
        });
    }, [items, shipping, advance_payment, setTotals]);
    const handleAdvancePaymentChange = (value) => {
        const val = parseFloat(value) || 0;
        if (val > calculatedTotals.grand_total) {
            setAdvancePayment(calculatedTotals.grand_total);
            toast.warning("Advance payment cannot exceed grand total");
        } else {
            setAdvancePayment(val);
        }
    };
    console.log(calculatedSubtotal, advance_payment);

    return (
        <>
            <div className="invoice-customer-summary">
                <div className="customer-note-summary">
                    <div className="oms-form-group">
                        <label htmlFor='customer-note' className="oms-form-label">
                            Customer note
                        </label>

                        <ReactQuill
                            theme="snow"
                            value={customerNote}
                            onChange={(e) =>
                                setCustomerNote(e)
                            }
                            style={{ backgroundColor: "#fefffc" }}
                            placeholder="Note for customer"
                            key={customerNote ? "note-loaded" : "note-empty"}
                        />
                        <p className="customer-note-p">
                            This will appear on the invoice.
                        </p>
                    </div>
                </div>
                <div className="invoice-summary">
                    <div className="invoice-summary-content">
                        {/* Subtotal Section */}
                        <div className="invoice-row">
                            <p className="invoice-label">Subtotal</p>
                            <strong>
                                {/* //<p className="invoice-value">₹{subtotal.toFixed(2)}</p> */}
                                <p className="invoice-value">₹{calculatedSubtotal.toFixed(2)}</p>

                            </strong>
                        </div>

                        <div className="invoice-row">
                            <p className="invoice-label">Discount Amount</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{discount_amount}
                                </p>
                            </strong>
                        </div>

                        <div className="invoice-row">
                            <div className="invoice-shipping">
                                <p className="invoice-label">Advance Payment</p>
                                <input
                                    type="number"
                                    name="advance_payment"
                                    placeholder="Enter Advance Payment"
                                    className="invoice-input"
                                    value={advance_payment === 0 ? "" : advance_payment}
                                    onChange={(e) => handleAdvancePaymentChange(e.target.value)}
                                // onChange={(e) => setAdvancePayment(parseFloat(e.target.value) || 0)}
                                />
                            </div>
                            <p className="invoice-value">₹{parseFloat(advance_payment || 0).toFixed(2)}</p>
                        </div>


                        <div className="invoice-row">
                            <p className="invoice-label">Tax</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{(
                                        (
                                            subtotal -
                                            ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)
                                        ) *
                                        (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100
                                    ).toFixed(2)}
                                </p>
                            </strong>
                        </div>


                        {/* Shipping Section */}
                        <div className="invoice-row">
                            <div className="invoice-shipping">
                                <p className="invoice-label">Service Fees/Shipping</p>
                                <input
                                    type="number"
                                    name="shipping"
                                    placeholder="Enter service fees/shipping"
                                    className="invoice-input"
                                    value={shipping === 0 ? "" : shipping}

                                    onChange={(e) =>
                                        setShipping(parseFloat(e.target.value) || 0)
                                    }
                                />
                            </div>
                            <p className="invoice-value">₹{parseFloat(shipping || 0).toFixed(2)}</p>
                        </div>


                        {/* <div className="invoice-row">
                            <p className="invoice-label">Pending</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{(
                                        subtotal -
                                        ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100) -
                                        (parseFloat(advance_payment) || 0) +
                                        (
                                            (subtotal -
                                                ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)) *
                                            (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100
                                        ) +
                                        (parseFloat(shipping || 0))
                                    ).toFixed(2)}
                                </p>
                            </strong>
                        </div> */}
                        {/* <div className="invoice-row">
                            <p className="invoice-label">Pending</p>
                            <strong>
                                <p className="invoice-value">₹{pendingAmount.toFixed(2)}</p>
                            </strong>
                        </div> */}


                        {/* Total Section */}
                        {/* <div className="invoice-row invoice-total">
                            <p className="invoice-label">Grand Total (₹)</p>
                            <p className="invoice-value invoice-grand-total">
                                ₹{(
                                    subtotal -
                                    ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100) +
                                    ((subtotal -
                                        ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)) *
                                        (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100) +
                                    (parseFloat(shipping) || 0)
                                ).toFixed(2)}
                            </p>
                        </div> */}
                        {/* <div className="invoice-row invoice-total">
                            <p className="invoice-label">Grand Total (₹)</p>
                            <p className="invoice-value invoice-grand-total">
                                ₹{grandTotal.toFixed(2)}
                            </p>
                        </div> */}
                        <div className="invoice-row">
                            <p className="invoice-label">Pending</p>
                            <strong>
                                <p className="invoice-value">{`₹${calculatedTotals.pending.toFixed(2)}`}</p>
                            </strong>
                        </div>

                        {/* Grand total */}
                        <div className="invoice-row invoice-total">
                            <p className="invoice-label">Grand Total (₹)</p>
                            <p className="invoice-value invoice-grand-total">
                                {`₹${calculatedTotals.grand_total.toFixed(2)}`}
                            </p>
                        </div>


                    </div>
                </div>
            </div>
        </>
    );
};

export default TotalSection;
